export default {
  'stock.minimumStock.form.companies': 'Companies',
  'stock.minimumStock.form.displayMinimumStock':
    'View Parts With Minimum Stock',
  'stock.minimumStock.form.belowStock': 'View Parts Below Minimum Stock',
  'stock.minimumStock.form.isActiveItems': 'Display Parts and/or Active Inputs',
  'stock.minimumStock.form.isInactiveItems':
    'Display Inactive Parts and/or Supplies',
  'stock.minimumStock.form.partTypes': 'Part Types',
  'stock.minimumStock.form.partTypes.parts': 'Parts',
  'stock.minimumStock.form.partTypes.inputs': 'Inputs',

  'stock.minimumStock.form.filterBy': 'Filter By',
  'stock.minimumStock.form.filterBy.internalCode': 'Internal Code',
  'stock.minimumStock.form.filterBy.manufacturingCode': 'Manufacturing Code',
  'stock.minimumStock.form.filterBy.barCode': 'Bar Code',
  'stock.minimumStock.form.filterBy.description': 'Description',
  'stock.minimumStock.form.filterBy.manufacturer': 'Manufacturer',
  'stock.minimumStock.form.filterBy.group': 'Group',
  'stock.minimumStock.form.filterBy.subGroup': 'Subgroup',

  'stock.minimumStock.form.in': 'In:',
  'stock.minimumStock.form.upUntil': 'Up Until:',
};
